import { useMutation } from "@tanstack/react-query";
import { googleCalendarApi } from "../api/googleCalendarApi";

// Busca a URL de consentimento do Google via chamada autenticada normal e só então
// navega a página inteira para ela — o token de sessão nunca entra na URL (ver
// googleCalendarApi.getConnectUrl).
export function useConnectGoogleCalendarMutation() {
  return useMutation({
    mutationFn: googleCalendarApi.getConnectUrl,
    onSuccess: (redirectUrl) => {
      window.location.href = redirectUrl;
    },
  });
}
